const styles = {
  main: {
    p: { xs: 2, lg: '16px 32px 16px 32px' },
    width: { xs: '100%', md: 536 },
    height: { xs: 165, md: 205 },
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0px 24px 24px rgba(174, 168, 207, 0.18)',
  },
  interviewDate: { display: 'flex', mt: { xs: 1.5, lg: 2 } },
  placesAvailable: {
    padding: { xs: '2px 4px 4px 4px', lg: '5px 8px 5px 8px' },
    display: 'inline-block',
    backgroundColor: '#E9E9FF',
    width: 'fit-content',
    borderRadius: '4px',
  },
  info: {
    display: 'flex',
    alignItems: {
      xs: 'flex-end',
      lg: 'center',
    },
    justifyContent: 'space-between',
    flexDirection: {
      xs: 'column',
      lg: 'row',
    },
    marginLeft: 'auto',
    width: {
      lg: '100%',
    },
  },
  startDate: {
    display: {
      xs: 'none',
      lg: 'inline',
    },
  },
  link: {
    flexShrink: 0,
    fontSize: {
      xs: '14px',
      lg: '16px',
    },
  },
  chipBlock: {
    width: {
      lg: '40%',
    },
    minWidth: {
      xs: 'auto',
      lg: '200px',
    },
  },
  chip: {
    '&.MuiChip-root': {
      borderRadius: {
        xs: '4px',
        lg: '8px',
      },
      padding: {
        xs: '4px 8px',
        lg: '9px 29px',
      },
      height: 'auto',
      marginRight: '0',
    },
    '& .MuiChip-label': {
      letterSpacing: '-0.01em',
      lineHeight: 1.1,
      padding: 0,
      fontSize: {
        xs: '12px',
        lg: '16px',
      },
    },
  },
};

export default styles;
